/**
 * [INPUT]: 依赖 React Router 路由、身份上下文与后台页面模块（含手动 ID 上架和公告控制面）
 * [OUTPUT]: 对外提供 admin-web 的受保护路由、MVP 上架、公告管理、AI 计费控制台、登录与未知路径回退
 * [POS]: admin-web 应用编排层，不包含具体领域查询与呈现细节
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { AdminLayout } from './components/AdminLayout';
import { isAdminSession, useAuth } from './context/auth';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { GamesPage } from './pages/GamesPage';
import { GameDetailPage } from './pages/GameDetailPage';
import { GameEditorPage } from './pages/GameEditorPage';
import { GameReleasesPage } from './pages/GameReleasesPage';
import { UsersPage } from './pages/UsersPage';
import { InspirationPage } from './pages/InspirationPage';
import { RedeemCodesPage } from './pages/RedeemCodesPage';
import { AIUsagePage } from './pages/AIUsagePage';
import { AIPriceRulesPage } from './pages/AIPriceRulesPage';
import { AuditLogsPage } from './pages/AuditLogsPage';
import { SystemSettingsPage } from './pages/SystemSettingsPage';
import { LLMChannelsPage } from './pages/LLMChannelsPage';
import { AnnouncementsPage } from './pages/AnnouncementsPage';
import { MvpPublishPage } from './pages/MvpPublishPage';
import { GamePromptPage } from './pages/GamePromptPage';

export default function App() {
  return <Routes><Route path="/login" element={<LoginPage />} /><Route element={<ProtectedLayout />}><Route path="/" element={<DashboardPage />} /><Route path="/publish" element={<MvpPublishPage />} /><Route path="/games" element={<GamesPage />} /><Route path="/games/new" element={<GameEditorPage />} /><Route path="/games/:id" element={<GameDetailPage />} /><Route path="/games/:id/edit" element={<GameEditorPage />} /><Route path="/games/:id/prompts" element={<GamePromptPage />} /><Route path="/games/:id/releases" element={<GameReleasesPage />} /><Route path="/announcements" element={<AnnouncementsPage />} /><Route path="/users" element={<UsersPage />} /><Route path="/inspiration" element={<InspirationPage />} /><Route path="/redeem-codes" element={<RedeemCodesPage />} /><Route path="/llm-channels" element={<LLMChannelsPage />} /><Route path="/ai-pricing" element={<AIPriceRulesPage />} /><Route path="/ai-usage" element={<AIUsagePage />} /><Route path="/audit-logs" element={<AuditLogsPage />} /><Route path="/settings" element={<SystemSettingsPage />} /><Route path="*" element={<Navigate to="/" replace />} /></Route></Routes>;
}

function ProtectedLayout() {
  const { session } = useAuth();
  if (!isAdminSession(session)) return <Navigate to="/login" replace />;
  return <AdminLayout><Outlet /></AdminLayout>;
}
